<template>
    <div>
        <Header />
        <img :class="s.homeBanner" :src="require('./images/aboutBg.jpg')" />
        <Partners />
        <Footer />
    </div>
</template>

<script>
import Header from './components/Header.vue';
import Partners from './components/Partners.vue';
import Footer from './components/Footer.vue';

export default {
    name: 'home',
    components: {
        Header,
        Partners,
        Footer,
    },
    computed: {
        s() {
            return this.$style;
        },
    },
    data() {
        return {
            msg: ''
        };
    },
};
</script>

<style scoped lang="less" module>
h3,
h4,
h5,
p {
    margin: 0;
}

.homeBanner {
    display: block;
    width: 100%;
    //   background: url("./images/aboutBg.jpg") center no-repeat;
    //   background-size: contain;
}
</style>
